module.exports = __webpack_public_path__ + "img/aziz.14acef8.svg";